import React from 'react'
import Style from '../viewSummary.module.css'
import ConnectorIcon from '../../../SharedComponents/ConnectorIcon/ConnectorIcon'
import { formatCount } from '../summaryFormat'

const Option = ({ from, to, total, errors, isActive, onSelect }) => (
    <button
        type="button"
        role="tab"
        aria-selected={isActive}
        className={[Style.direction, isActive ? Style.directionActive : ''].join(' ')}
        onClick={onSelect}
    >
        <span className={Style.directionSystems}>
            <span className={Style.systemIcon} title={from}>
                <ConnectorIcon shortName={from} className={Style.systemIconImg} />
            </span>
            <i className={`uil-arrow-right ${Style.directionArrow}`} aria-hidden="true" />
            <span className={Style.systemIcon} title={to}>
                <ConnectorIcon shortName={to} className={Style.systemIconImg} />
            </span>
        </span>
        <span className={Style.directionText}>
            <span className={Style.directionLabel}>{from} to {to}</span>
            <span className={Style.directionMeta}>
                {formatCount(total)} records
                {errors > 0 ? <span className={Style.directionErrors}> · {formatCount(errors)} failed</span> : null}
            </span>
        </span>
    </button>
)

/** Two-way switch between the source -> target and target -> source traffic. */
const DirectionSwitch = ({ sourceName, targetName, isSourceToTarget, onChange, totals }) => (
    <div className={Style.directions} role="tablist" aria-label="Sync direction">
        <Option
            from={sourceName}
            to={targetName}
            total={totals.source.total}
            errors={totals.source.error}
            isActive={isSourceToTarget}
            onSelect={() => onChange(true)}
        />
        <Option
            from={targetName}
            to={sourceName}
            total={totals.target.total}
            errors={totals.target.error}
            isActive={!isSourceToTarget}
            onSelect={() => onChange(false)}
        />
    </div>
)

export default DirectionSwitch
